<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { authStore } from '@/app/providers/auth';
import { handleAuthCallback, redirectToLogin } from '@/shared/lib/auth';

const router = useRouter();

const handleCallback = async () => {
    const result = await handleAuthCallback();
    if (!result.ok) {
        await redirectToLogin();
        return;
    }

    authStore.setTokens({
        accessToken: result.tokens.access_token,
        idToken: result.tokens.id_token,
        refreshToken: result.tokens.refresh_token,
    });

    router.push({ name: 'admin-top' });
};

onMounted(() => {
    handleCallback();
});
</script>

<template>
    <div />
</template>
